<template>
  <div class="d-flex">
    <div class="mr-1">
      {{ pageStart }}
    </div>
    <div>
      - {{ pageStop }}
    </div>
    <div v-if="!countExactFlag && !recordSpinner">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
              @click="runFetch"
              style="cursor: pointer"
              class="ml-3"
              v-bind="attrs"
              v-on="on"
              size="18"
              color="primary"
          >mdi-cached
          </v-icon>
        </template>
        <span>{{ $t('clickToCountAll') }}</span>
      </v-tooltip>
    </div>
    <div class="ml-1" v-if="countExactFlag && !recordSpinner">
      {{ `${$t('counterLabel')} ${totalElements}` }}
    </div>
    <div v-if="!countExactFlag && recordSpinner">
      <v-progress-circular
          class="ml-3"
          size="16"
          indeterminate
          color="primary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "TcnTableFooter",
  props: {
    page: {type: Number, default: 1},
    itemsPerPage: {type: Number, default: 25},
    itemsLength: {type: Number},
    pageStart: {type: Number},
    pageStop: {type: Number}
  },
  data() {
    return {
      recordSpinner: false,
      countExactFlag: false,
      totalElements: null,
      tempTotalElements: null
    }
  },
  computed: {},
  watch: {
    itemsLength: {
      handler() {
        console.log("Test")
        if (this.recordSpinner) {
          this.showExactCount()
        } else {
          if (this.page > 1) {
            if (this.page * this.itemsPerPage > this.itemsLength) {
              this.showExactCount()
            }

          } else if (this.page === 1 && this.itemsPerPage > this.itemsLength) {
            this.showExactCount()
          }

          if(this.itemsLength > this.totalElements) {
            this.recordSpinner = false
            this.countExactFlag = false
            this.totalElements = null
          }
        }
      },
      deep: true
    },
  },
  methods: {
    runFetch() {
      console.log("A - A")
      this.recordSpinner = true
      this.$emit("count")
    },

    showExactCount() {
      this.totalElements = this.itemsLength
      this.recordSpinner = false
      this.countExactFlag = true
    }
  }
}
</script>


<i18n lang="i18n">
{
  "en": {
    "clickToCountAll": "Press to calculate the exact number of records.",
    "counterLabel": "of"
  },
  "pl": {
    "clickToCountAll": "Naciśnij aby obliczyć dokładną liczbę rekordów.",
    "counterLabel": "z"
  }
}
</i18n>
